import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState, useContext, useCallback, useEffect } from 'react';
import dayjs from 'dayjs';
import style from './renderDays.module.scss.js';
import { DvCalendarContext } from './context.js';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
function RenderDays(_ref) {
  var _month = _ref._month,
    calSelection = _ref.calSelection,
    onDaySelected = _ref.onDaySelected,
    min = _ref.min,
    max = _ref.max,
    showWkSelection = _ref.showWkSelection,
    minWk = _ref.minWk,
    maxWk = _ref.maxWk,
    boxSz = _ref.boxSz,
    fontSz = _ref.fontSz;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    calDays = _useState2[0],
    setCalDays = _useState2[1];
  var _useContext = useContext(DvCalendarContext),
    locale = _useContext.locale;
  var monthL = 'month';
  var weekL = 'week';
  var dayL = 'day';
  var memoizedPrintDays = useCallback(function (pMonth) {
    var currMonth = dayjs().clone().set(monthL, pMonth);
    var startDay = currMonth.clone().startOf(monthL).startOf(weekL);
    var endDay = currMonth.clone().endOf(monthL).endOf(weekL);
    var day = startDay.clone().subtract(1, dayL);
    var blank = [];
    while (day.isBefore(endDay, dayL)) {
      day = day.clone().add(1, dayL);
      blank.push(day);
    }
    setCalDays(blank);
  }, []);
  useEffect(function () {
    dayjs.locale(locale);
    printDays(_month);
  }, [_month, locale.name]);
  function printDays(pMonth) {
    memoizedPrintDays(pMonth);
  }
  function addStyles(day) {
    var start = calSelection.start,
      end = calSelection.end;
    var noUserSelection = [start, end].includes(undefined);
    if (showWkSelection) {
      var minWkStartDt = minWk.startOf(weekL);
      var maxWkEndDt = maxWk.endOf(weekL);
      if (day.isBefore(minWkStartDt, dayL) || day.isAfter(maxWkEndDt, dayL) || noUserSelection || day.isBefore(start, dayL) || day.isAfter(end, dayL)) {
        return "".concat(style.block, " ").concat(style.disabled, " ").concat(style.defaultCursor);
      }
    } else if (day.isBefore(min, dayL) || day.isAfter(max, dayL)) {
      return "".concat(style.block, " ").concat(style.disabled, " ").concat(style.defaultCursor);
    }
    if (!noUserSelection) {
      if (day.isSame(start, dayL) || day.isSame(end, dayL)) {
        return "".concat(style.block, " ").concat(style.range);
      }
      if (day.isSameOrAfter(start, dayL) && day.isSameOrBefore(end, dayL)) {
        return "".concat(style.block, " ").concat(style.daySelected);
      }
    }
    var currDate = dayjs();
    if (day.isBefore(currDate, 'day')) {
      return "".concat(style.block, " ").concat(style.prevDays);
    }
    if (day.isAfter(currDate, 'day')) {
      return "".concat(style.block, " ").concat(style.nextDays);
    }

    // today
    return "".concat(style.block, " ").concat(style.today);
  }
  function handleDayClick(d) {
    if (d.isBefore(min, dayL) || d.isAfter(max, dayL)) {
      return;
    }
    if (showWkSelection) {
      return;
    }
    onDaySelected(d);
  }
  function addBgStyle(day) {
    var defaultCls = style.dayTransparent;
    var start = calSelection.start,
      end = calSelection.end;
    if (![start, end].includes(undefined)) {
      if (day.isSame(start, dayL)) {
        defaultCls = "".concat(style.dayBg, " ").concat(style.dayBgBorderStart);
      }
      if (day.isSame(end, dayL)) {
        defaultCls = "".concat(style.dayBg, " ").concat(style.dayBgBorderEnd);
      }
    }
    if (showWkSelection) {
      return "".concat(defaultCls, " ").concat(style.defaultCursor);
    }
    return "".concat(defaultCls, " ").concat(style.pointerCursor);
  }
  return calDays.map(function (d, idx) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: addBgStyle(d),
      key: "".concat(d.month()).concat(d.date()).concat(idx, "}"),
      "data-testid": 'outerbox'
    }, /*#__PURE__*/React__default.createElement("div", {
      role: "button",
      "data-testid": "day-".concat(dayjs(d).date(), "-").concat(dayjs(d).month()),
      id: "day-".concat(dayjs(d).date(), "-").concat(dayjs(d).month()),
      className: addStyles(d),
      onClick: function onClick() {
        return handleDayClick(d);
      },
      style: {
        width: boxSz,
        height: boxSz,
        fontSize: fontSz
      }
    }, d.clone().format('D')));
  });
}

export { RenderDays as default };
